<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<br/><p style="text-indent:00em;">I would like to dedicate this book to my dear friend, Anne, for her generous time in reading and critiquing my stories.</p>
<br/><p style="text-indent:00em;">To my lovely friend, Sue, for some truly inspiring suggestions. Her knowledge of demonology and the Catholic Church is immense and proved very helpful, and to my three lovely daughters, Louise, Kate and Rebekah.</p>
<br/><p style="text-indent:00em;">I love you all and am grateful for your continued love, support and encouragement.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?7dc6f21e